import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Checkbox,
  styled,
  Grid,
  Slider,
  SliderThumb,
} from '@mui/material';
import ClipboardJS from 'clipboard';

import ScrollArea from 'react-scrollbar';
import CustomButton from '../CustomButton';

import imgAvax from '../../assets/images/avax.png';

import imgHeimdall from '../../assets/images/svg/heimdall-node-gold.svg';
import imgFreya from '../../assets/images/svg/freya-node-gold.svg';
import imgOdin from '../../assets/images/svg/odin-node-gold.svg';
import imgThor from '../../assets/images/svg/thor-node-gold.svg';

import imgFantom from '../../assets/images/fantom.png';
import imgCopy from '../../assets/images/copy.png';
import imgSearch from '../../assets/images/search.png';
import imgFilter from '../../assets/images/filter.png';
import imgClose from '../../assets/images/close.png';
import imgNodeCard1 from '../../assets/images/cards/nodeCard1.png';
import imgNodeCard2 from '../../assets/images/cards/nodeCard2.png';
import imgNodeCard3 from '../../assets/images/cards/nodeCard3.png';

import hemidalSilver from '../../assets/images/svg/heimdall-node-silver.svg';
import odinSilver from '../../assets/images/svg/odin-node-silver.svg';
import thorSilver from '../../assets/images/svg/thor-node-silver.svg';
import freyaSilver from '../../assets/images/svg/freya-node-silver.svg';

// import imgHeimdall from '../../assets/images/svg/heimdall-node-gold.svg';
// import imgOdin from '../../assets/images/svg/odin-node-gold.svg';
// import imgThor from '../../assets/images/svg/thor-node-gold.svg';
// import imgFreya from '../../assets/images/svg/freya-node-gold.svg';

import { MdOutlineKeyboardArrowDown } from 'react-icons/md';

import OutlinedButton from '../CustomButton/OutlinedButton';
import SearchBar from '../SearchBar';
import Modal from 'react-bootstrap/Modal';
import useWindowDimensions from '../../dimension';

import { dateDiffInDays, getNumber } from '../../utils/utils';
import FilterModal from '../FilterModal';
import { useGetNodesV2, useGetNodeRewards } from '../../hooks/nodes';
import { getNodeChecksum, useGetDueDate, useGetIsDelinquent, usePayFees } from '../../hooks/masterOfCoin';
import { tierFees } from '../../hooks/bitfrostLibrary';

import styles from './style.module.css';
import './style.css';
import { useQuery } from 'react-query';
import axios from 'axios';
import { keyBy } from 'lodash';
import { useCashOutReward } from '../../hooks/token';

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 16,
  height: 16,
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 0 0 1px rgb(16 22 26 / 40%)'
      : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  backgroundImage:
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
      : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

function BpCheckbox(props) {
  return (
    <Checkbox
      sx={{
        '&:hover': { bgcolor: 'transparent' },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      inputProps={{ 'aria-label': 'Checkbox demo' }}
      {...props}
    />
  );
}

// Check Icon 2

const FilterIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: '24px',
  height: '24px',
  border: '1.5px solid #32B267',
  backgroundColor: 'transparent',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
  },
}));

const FilterCheckedIcon = styled(FilterIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: '24px',
    height: '24px',
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

function FilterCheckbox(props) {
  return (
    <Checkbox
      sx={{
        '&:hover': { bgcolor: 'transparent' },
      }}
      disableRipple
      color="default"
      checkedIcon={<FilterCheckedIcon />}
      icon={<FilterIcon />}
      inputProps={{ 'aria-label': 'Checkbox demo' }}
      {...props}
    />
  );
}

const AirbnbSlider = styled(Slider)(({ theme }) => ({
  color: '#A88D47;',
  height: 3,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: '16px',
    width: '4px',
    borderRadius: '0',
    backgroundColor:
      'linear-gradient(131.78deg, #EEEEEE 12.72%, #D4C78C 21.39%, #DEBF70 34.64%, #AE9555 44.61%, #A78C47 57.04%)',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
  },
  '& .MuiSlider-track': {
    height: 3,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#A88D47',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: '4px',
  },
  '& .MuiSlider-markLabel': {
    color: 'rgba(255, 255, 255, 0.4)',
  },
}));

function AirbnbThumbComponent(props) {
  const { children, ...other } = props;
  return <SliderThumb {...other}>{children}</SliderThumb>;
}

const marks = [
  {
    value: 0,
    label: 'All',
  },
  {
    value: 20,
    label: '50%',
  },
  {
    value: 40,
    label: '40%',
  },
  {
    value: 60,
    label: '30%',
  },
  {
    value: 80,
    label: '20%',
  },
  {
    value: 100,
    label: 'Flat',
  },
];

const tierImages = {
  ODIN: {
    table_img: imgOdin,
  },
  FREYA: {
    table_img: imgFreya,
  },
  THOR: {
    table_img: imgThor,
  },
  HEIMDALL: {
    table_img: imgHeimdall,
  },
};

const Reward = ({ createdAt, tier, node }) => {
  const web3context = useSelector((state) => state.web3.web3context);
  const account = web3context?.account;

  const reward = useGetNodeRewards(tier, createdAt);
  const nodeId = getNodeChecksum(node.name, node.createdAt, node.tier, String(account));
  const isDelinquent = useGetIsDelinquent(nodeId);

  const rewards = isDelinquent.data ? 0 : reward.data && getNumber(reward.data, 6);

  return <>{rewards ? rewards : 0}</>;
};

const Claim = ({ createdAt, onClaim, tier, name, all, ...props }) => {
  const { cashOutReward, isLoading } = useCashOutReward(tier, name);
  return (
    <Box marginLeft={3}>
      <CustomButton
        className={styles.claim_btn2}
        label={!all ? 'claim' : 'claim all'}
        {...props}
        onClick={() =>
          cashOutReward([createdAt])
            .then(onClaim)
            .then(() => setTimeout(onClaim, 2000))
        }
      />
    </Box>
  );
};

const PayFee = ({ node }) => {
  const web3context = useSelector((state) => state.web3.web3context);
  const account = web3context?.account;

  const nodeId = getNodeChecksum(node.name, node.createdAt, node.tier, String(account));
  const { payFees, isLoading } = usePayFees();
  const dueDate = useGetDueDate(nodeId);
  return (
    <Box marginLeft={2}>
      <OutlinedButton
        loading={isLoading}
        className={styles.payfee_btn}
        label="pay fee"
        onClick={() =>
          payFees([[nodeId], node.tier])
            .then(dueDate.refetch)
            .then(() => setTimeout(dueDate.refetch, 5000))
        }
      />
    </Box>
  );
};

const CopyRpc = ({ node }) => {
  const web3context = useSelector((state) => state.web3.web3context);
  const account = web3context?.account;

  const [activeRpc, setActiveRPC] = useState(0);
  const [showDrp, setShowDrp] = useState(false);
  const [copyStatus1, setCopyStatus1] = useState(false);
  const [copyStatus2, setCopyStatus2] = useState(true);

  const rpcDrpDown = [
    {
      img: imgAvax,
    },
    {
      img: imgFantom,
    },
  ];

  const handleOnCopyHttp = async (txt) => {
    navigator.clipboard.writeText(txt);
    setCopyStatus1(true);
    await new Promise((res) => setTimeout(res, 1000));
    setCopyStatus1(false);
  };

  const handleOnCopyWss = async (txt) => {
    navigator.clipboard.writeText(txt);
    setCopyStatus2(false);
    await new Promise((res) => setTimeout(res, 1000));
    setCopyStatus2(true);
  };

  const { data = {}, isLoading: isFetching } = useQuery(
    ['rpcs', account],
    async () => {
      const response = await axios.post('https://api.thor.financial/create_rpc/', { address: account });

      return keyBy(response.data, 'checksum');
    },
    {
      enabled: Boolean(account),
      refetchInterval: 15000,
    },
  );

  const checksum = `${node.name}${node.createdAt}${node.tier}`;
  const rpc = data[checksum] || null;

  if (rpc) {
    rpc.tier = node.tier;
  }

  const avax = `https://rpc.thor.financial/node/${rpc?.node_id}`;
  const avaxWss = `wss://rpc.thor.financial/node/${rpc?.node_id}`;

  const ftm = `https://ftm.thor.financial/node/${rpc?.node_id}`;
  const ftmWss = `wss://ftm.thor.financial/node/${rpc?.node_id}`;

  return (
    <Box display={'flex'} className={styles.twrap} alignItems="center" flexDirection="column">
      <Box className={`${styles.tooltipContainer} tooltipContainer`} onClick={() => setShowDrp(true)}>
        <img src={rpcDrpDown[activeRpc].img} alt="AVAX" width={'24px'} height={'24px'} />
        <Box marginLeft={'3px'} marginTop="5px">
          <MdOutlineKeyboardArrowDown fontSize={'18px'} color="white" />
        </Box>
      </Box>
      <Box className={styles.tooltip} style={{ marginTop: '40px' }}>
        <Box
          onClick={() => {
            handleOnCopyHttp(activeRpc === 0 ? avax : ftm);
          }}
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginBottom: '10px' }}
          className="copy_btn"
          data-clipboard-action="copy"
          data-clipboard-target="#text_link"
        >
          <img src={imgCopy} alt="copy" width="8px" height={'8px'} />
          <p style={{ color: !copyStatus1 ? 'rgba(255, 255, 255, 0.5)' : '#32B267' }} className={styles.copyTxt}>
            {!copyStatus1 ? 'COPY' : 'COPIED'}
          </p>
        </Box>
        <p id="text_link" className={styles.para}>
          {activeRpc === 0 ? avax : ftm}
        </p>

        <Box marginTop="10px">
          <a
            href="https://thornodes.medium.com/how-to-add-thor-nodes-to-metamask-a5336e01bdb7"
            target="_blank"
            className={styles.copyTxt}
            style={{ textAlign: 'center' }}
          >
            HOW TO
          </a>
        </Box>
      </Box>

      {showDrp ? (
        <Box className="rpc_menu">
          {rpcDrpDown.map((d, ind) => {
            return (
              <Box
                key={ind}
                onClick={() => {
                  setActiveRPC(ind);
                  setShowDrp(!showDrp);
                }}
              >
                <img src={d.img} alt="..." />
              </Box>
            );
          })}
        </Box>
      ) : (
        ''
      )}
    </Box>
  );
};

const InvestTable = ({nodes}) => {  
  const { nodeName } = useParams();
  const { width } = useWindowDimensions();
  const [searchbar, setSearchbar] = useState(false);
  const [show, setShow] = useState(false);
  const [view, setView] = useState(false);
  const [nodeData, setNodeData] = useState([
    {
      nonActive: hemidalSilver,
      active: imgHeimdall,
      isActive: true,
      name: 'heimdall',
    },
    {
      nonActive: freyaSilver,
      active: imgFreya,
      isActive: true,
      name: 'freya',
    },
    {
      nonActive: thorSilver,
      active: imgThor,
      isActive: true,
      name: 'thor',
    },
    {
      nonActive: odinSilver,
      active: imgOdin,
      isActive: true,
      name: 'odin',
    },
  ]);
  const [rangeValue, setRangeValue] = useState([0, 50]);
  const [selectedNodes, setSelectedNodes] = useState({
    odin: true,
    thor: true,
    freya: true,
    heimdall: true,
  });

  const getNextTierInfo = (lastClaimTime, tier) => {
    const daysSinceLastClaim = dateDiffInDays(new Date(), new Date(Number(lastClaimTime) * 1000));
    let daysUntilNextClaim = 0;
    let nextTierPercent = tierFees[tier];
    if (daysSinceLastClaim < 7) {
      daysUntilNextClaim = 7 - daysSinceLastClaim;
      nextTierPercent = '40';
    } else if (daysSinceLastClaim < 14) {
      daysUntilNextClaim = 14 - daysSinceLastClaim;
      nextTierPercent = '30';
    } else if (daysSinceLastClaim < 21) {
      daysUntilNextClaim = 21 - daysSinceLastClaim;
      nextTierPercent = '20';
    } else if (daysSinceLastClaim < 28) {
      daysUntilNextClaim = 28 - daysSinceLastClaim;
    }

    return { daysSinceLastClaim, daysUntilNextClaim, nextTierPercent };
  };

  const getBars = (count) => {
    let bars = [];
    let i = 0;
    for (; i < count; i++) {
      bars.push({
        className: styles.gold,
      });
    }
    for (; i < 7; i++) {
      bars.push({
        className: styles.silver,
      });
    }

    return bars;
  };

  const getData = () => {
    return nodes && nodes.data
      ? nodes.data.map((node) => {
          const nextTierInfo = getNextTierInfo(node.lastClaimTime, node.tier);
          return {
            className: 'INACTIVE' === node?.status?.status ? 'inactive' : undefined,
            name: node.name,
            img: tierImages[node.tier].table_img,
            nodeName: node.tier,
            Date: new Date(Number(node.createdAt) * 1000).toLocaleString(),
            rewards: <Reward createdAt={node.createdAt} tier={node.tier} node={node} />,
            tax: node.tax,
            taxData: getBars(nextTierInfo.daysUntilNextClaim),
            selectedImg: imgAvax,
            copy: false,
            rpc: [
              {
                img: imgAvax,
              },
              {
                img: imgFantom,
              },
            ],
            daysLeft: node.daysLeft,
            ...node,
            ...nextTierInfo,
          };
        })
      : [];
  };

  const [status, setStatus] = useState(null);
  const [inputState, setInputState] = useState({
    search1: '',
    search2: '',
  });
  new ClipboardJS('.copy_btn');

  const boxClickHandler = (i, bool) => {
    if (i === 'all') {
      setSelectedNodes((prevState) => {
        for (const key in prevState) {
          prevState[key] = true;
        }

        return { ...prevState };
      });
    } else {
      if (bool) {
        setSelectedNodes((prevState2) => {
          return { ...prevState2, [nodeData[i].name]: false };
        });
      } else {
        setSelectedNodes((prevState2) => {
          return { ...prevState2, [nodeData[i].name]: true };
        });
      }
    }
  };

  const searchChangeHandler = (e) => {
    const { name, value } = e.target;

    setInputState((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    if (nodeName) {
      setSelectedNodes({ [nodeName]: true });
    }
  }, [nodeName]);
  return (
    <>
      <Box>
        <Box
          className={styles.topBtn}
          display={'flex'}
          justifyContent="space-between"
          alignItems="flex-end"
          marginBottom="20px"
        >
          <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
            <Modal.Body
              style={{
                background: 'none',
                padding: '0px 20px',
                backdropFilter: 'blur(28px)',
                WebkitBackdropFilter: 'blur(2px)',
              }}
            >
              <Box display={'flex'} justifyContent="space-between" alignItems={'center'} marginTop={'70px'}>
                <Box>
                  <Typography
                    sx={{
                      fontSize: '24px',
                      fontFamily: 'Kanit',
                      fontWeight: 500,
                      color: 'rgba(255, 255, 255, 0.5)',
                    }}
                  >
                    Filter by
                  </Typography>
                </Box>
                <Box>
                  <IconButton onClick={() => setShow(false)}>
                    <img src={imgClose} alt="close" width={'20px'} height="20px" />
                  </IconButton>
                </Box>
              </Box>
              <Box display={'flex'} justifyContent="space-between" alignItems={'center'} marginTop={'30px'}>
                <Box>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontFamily: 'Kanit',
                      fontWeight: 500,
                      color: 'white',
                    }}
                  >
                    Filter by
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontFamily: 'Kanit',
                      fontWeight: 500,
                      color: 'rgba(255, 255, 255, 0.6)',
                    }}
                  >
                    All
                  </Typography>
                </Box>
              </Box>
              <Grid container spacing={2} marginTop="10px">
                <Grid item xs={3}>
                  <Box
                    sx={{
                      height: '72px',
                      background: '#11141D',
                      boxShadow:
                        '0px -0.911392px 14.5823px rgba(222, 191, 112, 0.1), 0px 3.64557px 3.64557px rgba(0, 0, 0, 0.25)',
                      borderRadius: '10px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      border: '0.91px solid',
                    }}
                  >
                    <img src={imgNodeCard1} alt="thor" width={'80%'} />
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box
                    sx={{
                      height: '72px',
                      background: '#11141D',
                      boxShadow:
                        '0px -0.911392px 14.5823px rgba(222, 191, 112, 0.1), 0px 3.64557px 3.64557px rgba(0, 0, 0, 0.25)',
                      borderRadius: '10px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <img src={imgNodeCard2} alt="thor" width={'80%'} />
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box
                    sx={{
                      height: '72px',
                      background: '#11141D',
                      boxShadow:
                        '0px -0.911392px 14.5823px rgba(222, 191, 112, 0.1), 0px 3.64557px 3.64557px rgba(0, 0, 0, 0.25)',
                      borderRadius: '10px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <img src={imgNodeCard3} alt="thor" width={'80%'} />
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box
                    sx={{
                      height: '72px',
                      background: '#11141D',
                      boxShadow:
                        '0px -0.911392px 14.5823px rgba(222, 191, 112, 0.1), 0px 3.64557px 3.64557px rgba(0, 0, 0, 0.25)',
                      borderRadius: '10px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <img src={imgNodeCard1} alt="thor" width={'80%'} />
                  </Box>
                </Grid>
              </Grid>

              <Box
                sx={{
                  width: '100%',
                  marginTop: '20px',
                  height: 0,
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                }}
              ></Box>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '20px',
                }}
              >
                <Typography sx={{ fontFamily: 'Kanit', fontSize: '14px', color: 'white' }}>Tax Tier</Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontFamily: 'Kanit',
                    fontWeight: 500,
                    color: 'rgba(255, 255, 255, 0.6)',
                  }}
                >
                  All
                </Typography>
              </Box>
              <Box>
                <AirbnbSlider
                  track={false}
                  components={{ Thumb: AirbnbThumbComponent }}
                  getAriaLabel={(index) => (index === 0 ? 'Minimum price' : 'Maximum price')}
                  defaultValue={[20, 40]}
                  marks={marks}
                />
              </Box>

              <Box
                sx={{
                  width: '100%',
                  marginTop: '20px',
                  height: 0,
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                }}
              ></Box>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '20px',
                }}
              >
                <Typography sx={{ fontFamily: 'Kanit', fontSize: '14px', color: 'white' }}>Status</Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontFamily: 'Kanit',
                    fontWeight: 500,
                    color: 'rgba(255, 255, 255, 0.6)',
                  }}
                >
                  All
                </Typography>
              </Box>
              <Box marginTop={'10px'} display="flex">
                <Box flex="1" display={'flex'} alignItems="center">
                  <Box>
                    <FilterCheckbox />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: 'Kanit',
                        fontSize: '12px',
                        color: 'white',
                      }}
                    >
                      GOOD STANDING
                    </Typography>
                  </Box>
                </Box>
                <Box flex="1" display={'flex'} alignItems="center">
                  <Box>
                    <FilterCheckbox />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: 'Kanit',
                        fontSize: '12px',
                        color: 'white',
                      }}
                    >
                      OVERDUE
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box marginTop={'10px'} display="flex">
                <Box flex="1" display={'flex'} alignItems="center">
                  <Box>
                    <FilterCheckbox />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: 'Kanit',
                        fontSize: '12px',
                        color: 'white',
                      }}
                    >
                      DUE SOON
                    </Typography>
                  </Box>
                </Box>
                <Box flex="1" display={'flex'} alignItems="center">
                  <Box>
                    <FilterCheckbox />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: 'Kanit',
                        fontSize: '12px',
                        color: 'white',
                      }}
                    >
                      INACTIVE
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Modal.Body>
          </Modal>
          {width > 700 ? (
            <Box display={'flex'} alignItems="center">
              <Box>
                <Box className={styles.inpBox}>
                  <input
                    type="text"
                    placeholder="Search nodes"
                    value={inputState.search1}
                    name="search1"
                    onChange={searchChangeHandler}
                    className={styles.inpSearch}
                  />
                  <IconButton aria-label="search" className={styles.btnSearch}>
                    <img src={imgSearch} alt="search" width="16px" height="16px" />
                  </IconButton>
                </Box>
              </Box>
              <Box
                className="filter_wrap"
                onClick={() => setView(!view)}
                sx={{
                  minWidth: 100,
                  display: 'flex',
                  cursor: 'pointer',
                  alignItems: 'center',
                  padding: '10px 0px',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #FFFFFF',
                  marginLeft: '40px',
                }}
              >
                <Typography
                  sx={{
                    color: 'white',
                    fontSize: '18px',
                    fontFamily: 'Kanit',
                    fontWeight: 300,
                    cursor: 'pointer',
                  }}
                >
                  Filter By
                </Typography>
                <MdOutlineKeyboardArrowDown color="white" fontSize={22} />
              </Box>
              {view ? (
                <FilterModal
                  boxClickHandler={boxClickHandler}
                  nodeData={nodeData}
                  selectedNodes={selectedNodes}
                  view={view}
                  setView={setView}
                  status={status}
                  setStatus={setStatus}
                  rangeValue={rangeValue}
                  setRangeValue={setRangeValue}
                />
              ) : (
                ''
              )}
            </Box>
          ) : (
            <Box>
              <IconButton aria-label="search" onClick={() => setSearchbar(!searchbar)}>
                <img src={imgSearch} alt="search" width="16px" height="16px" />
              </IconButton>
              <IconButton aria-label="filter" onClick={() => setView(!view)}>
                <img src={imgFilter} alt="search" width="16px" height="16px" />
              </IconButton>
              {view ? (
                <FilterModal
                  boxClickHandler={boxClickHandler}
                  nodeData={nodeData}
                  selectedNodes={selectedNodes}
                  setNodeData={setNodeData}
                  view={view}
                  setView={setView}
                  status={status}
                  setStatus={setStatus}
                  rangeValue={rangeValue}
                  setRangeValue={setRangeValue}
                />
              ) : (
                ''
              )}
            </Box>
          )}

          <Box display={'flex'} alignItems="center">
            <Box>
              <Claim onClaim={nodes.refetch} all={true}/>
            </Box>
            <Box marginLeft={2}>
              <OutlinedButton className={styles.payfee_btn2} label={'pay all'} />
            </Box>
          </Box>
        </Box>
      </Box>

      {searchbar ? (
        <Box paddingX="20px" marginBottom={'20px'}>
          <SearchBar
            value={inputState.search1}
            name="search1"
            onChange={searchChangeHandler}
            placeholder={'Search Node'}
          />
        </Box>
      ) : null}
      {/* height:40vh */}
      <ScrollArea speed={0.8} contentClassName="content" horizontal={true} vertical={true}>
        <TableContainer
          className={`${styles.TableContainer} tableContainer`}
          // component={Paper}
          sx={{
            background: 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.48)',
          }}
          style={{
            backgroundColor: 'transparent',
            borderRadius: '12px',
            width: '100%',
            height: '100%',
            overflowX: 'auto',
          }}
        >
          <Table
            className={styles.nodeTable}
            sx={{
              minWidth: 700,
            }}
            // aria-label="simple table"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                {width < 700 ? (
                  <TableCell
                    sx={{
                      fontWeight: '500',
                      color: 'rgba(151,155,172,0.5)',
                      fontFamily: 'Kanit',
                    }}
                  >
                    <BpCheckbox />
                  </TableCell>
                ) : null}
                <TableCell
                  sx={{
                    fontWeight: '500',
                    color: 'rgba(151,155,172,0.5)',
                    fontFamily: 'Kanit',
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontFamily: 'Kanit',
                    color: 'rgba(151,155,172,0.5)',
                  }}
                >
                  Warrior
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    color: 'rgba(151,155,172,0.5)',
                    fontFamily: 'Kanit',
                  }}
                >
                  Date/Time
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontFamily: 'Kanit',
                    color: 'rgba(151,155,172,0.5)',
                  }}
                >
                  Rewards
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontFamily: 'Kanit',
                    color: 'rgba(151,155,172,0.5)',
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontFamily: 'Kanit',
                    color: 'rgba(151,155,172,0.5)',
                  }}
                >
                  Tax
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 500,
                    fontFamily: 'Kanit',
                    color: 'rgba(151,155,172,0.5)',
                  }}
                >
                  RPC
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={styles.tbody}>
              {nodes && nodes.isLoading && (
                <Typography sx={{ color: 'white', textAlign: 'center', paddingTop: '15px' }}>loading ...</Typography>
              )}
              {nodes && !nodes.isLoading && nodes.data?.length === 0 && (
                <Typography sx={{ color: 'white', textAlign: 'center', paddingTop: '15px' }}>
                  no records found
                </Typography>
              )}
              {nodes &&
                !nodes.isLoading &&
                nodes.data &&
                getData().map((v, i) => {
                  if (!(v.tax >= rangeValue[0] && v.tax <= rangeValue[1])) {
                    return <></>;
                  }

                  if (status !== null) {
                    if (status === 0) {
                      if (!(v.daysLeft >= 6)) {
                        return <></>;
                      }
                    } else if (status === 2) {
                      if (!(v.daysLeft >= 1 && v.daysLeft <= 5)) {
                        return <></>;
                      }
                    } else if (status === 1) {
                      if (!(v.daysLeft === 0)) {
                        return <></>;
                      }
                    } else if (status === 3) {
                      if (!(v.daysLeft === null)) {
                        return <></>;
                      }
                    }
                  }
                  if (!selectedNodes[v.nodeName.toLowerCase()]) {
                    return <></>;
                  }
                  v.hide = true;
                  if (
                    (v.nodeName.toLowerCase() + ' ' + v.name.toLowerCase()).includes(inputState.search1.toLowerCase())
                  ) {
                    v.hide = false;
                  }
                  if (v.hide) {
                    return <></>;
                  }
                  return (
                    <TableRow key={i} className={v.className}>
                      {width < 700 ? (
                        <TableCell
                          sx={{
                            fontWeight: '500',
                            color: 'rgba(151,155,172,0.5)',
                            fontFamily: 'Kanit',
                          }}
                        >
                          <BpCheckbox />
                        </TableCell>
                      ) : null}
                      <TableCell>
                        <Typography
                          variant="subtitle1"
                          component="div"
                          sx={{
                            color: 'white',
                            fontFamily: 'Kanit',
                            fontWeight: 300,
                          }}
                        >
                          {v.name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems={'center'}>
                          <Box>
                            <img src={v.img} alt="AVAX" width={30} />
                          </Box>
                          <Box marginLeft={2}>
                            <Typography
                              variant="subtitle1"
                              component="div"
                              sx={{
                                color: 'white',
                                fontFamily: 'Trojan',
                                fontWeight: 400,
                              }}
                            >
                              {v.nodeName}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="subtitle1"
                          component="div"
                          sx={{
                            color: 'white',
                            fontFamily: 'Kanit',
                            fontWeight: 300,
                          }}
                        >
                          {v.Date}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="subtitle1"
                          component="div"
                          sx={{
                            color: '#fff',
                            fontFamily: 'Kanit',
                            fontWeight: 300,
                          }}
                        >
                          {v.rewards}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box display={'flex'} alignItems="center">
                          <Box
                            sx={{
                              width: '10px',
                              height: '10px',
                              backgroundColor: `${v.status.color}`,
                              borderRadius: '50%',
                            }}
                          ></Box>
                          <Typography
                            variant="subtitle3"
                            component="div"
                            sx={{
                              color: 'white',
                              fontFamily: 'Kanit',
                              fontWeight: 300,
                              marginLeft: 1,
                            }}
                          >
                            {v.status.table_status}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell className={styles.taxWrap}>
                        <Typography
                          variant="subtitle1"
                          component="div"
                          sx={{
                            color: '#fff',
                            fontFamily: 'Kanit',
                            fontWeight: 300,
                            display: 'flex',
                            alignItems: 'center',
                            position: 'relative',
                          }}
                        >
                          {v.tax}%
                          <Box className={styles.percent_wrap}>
                            {v.taxData.map((t, i) => {
                              return (
                                <Box key={i} className={t.className}>
                                  <span>.</span>
                                </Box>
                              );
                            })}
                          </Box>
                        </Typography>

                        <Box className={styles.tooltip2}>
                          <h2>{`${v.nextTierPercent + '% TAX TIER IN'}`}</h2>
                          <strong>{`${v.daysUntilNextClaim} DAYS`}</strong>
                          <h2>LAST CLAIM DATE</h2>
                          <strong>{new Date(Number(v.lastClaimTime) * 1000).toLocaleString()}</strong>
                          <hr />
                          <a
                            href="https://thornodes.medium.com/thor-claim-tax-tier-system-update-information-breakdown-105b65700457"
                            target="_blank"
                          >
                            <strong>SEE TAX BRACKETS</strong>
                          </a>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display={'flex'} alignItems="center" className={styles.boxxxx}>
                          <CopyRpc node={v} />
                          <Claim createdAt={v.createdAt} onClaim={nodes.refetch} tier={v.tier} name={v.name} />
                          <PayFee node={v} />
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </ScrollArea>
    </>
  );
};

export default InvestTable;
